<template>
    <div class="levelBox">
        <el-form :model="model" ref="model" label-width="100px" class="demo-dynamic">
            <!--<div class="flex-row vertical-center">-->
                <!--<el-form-item label="等级名称" prop="levelId">-->
                    <!--<el-select v-model="model.levelName" placeholder="请选择等级名称" :disabled="show">-->
                        <!--<el-option-->
                            <!--v-for="item in levelNameList"-->
                            <!--:key="item.id"-->
                            <!--:label="item.levelName"-->
                            <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <!--&lt;!&ndash;<el-button type="primary" class="button-size" style="margin-left: 20px" @click="submitForm('model')">&ndash;&gt;-->
                    <!--&lt;!&ndash;保存&ndash;&gt;-->
                <!--&lt;!&ndash;</el-button>&ndash;&gt;-->
            <!--</div>-->
            <div class="item-box" v-if="showList">
                <div class="flex-row vertical-center item" v-for="(item, index) in model.lineList" :key="index">
                    <el-tooltip class="item" effect="dark" :content="`费率：${item.tatRate}%， 代付费： ${toDoubleThousands(item.tatAmt * 100 /10000)}元`" placement="top-start">
                        <p class="lineName">{{item.lineName}}</p>
                    </el-tooltip>
                    <el-form-item label="费率" :prop="'lineList.' + index + '.qpayRate'">
                        <!--<el-input v-model="item.qpayRate" placeholder="请输入费率"></el-input>-->
                        <el-input-number placeholder="请输入费率" :controls="false" v-model="item.qpayRate"
                                         controls-position="right" :min="0" :precision="3" :disabled="!needEdit"
                                         :step="0.001"></el-input-number>
                        <p>(%)</p>
                    </el-form-item>
                    <el-form-item label="代付费用" :prop="'lineList.' + index + '.qpayAmt'">
                        <!--<el-input v-model="item.qpayAmt" placeholder="请输入代付费率"></el-input>-->
                        <el-input-number placeholder="请输入代付费用" :controls="false" v-model="item.qpayAmt"
                                         controls-position="right" :min="0" :precision="2"  :disabled="!needEdit"
                                         :step="0.1"></el-input-number>
                        <p>(元/笔)</p>
                    </el-form-item>
                </div>
            </div>
            <p class="notice-text" v-else> 暂无通道信息</p>
        </el-form>
    </div>
</template>

<script>
    import MemberLevelService from 'service/MemberLevelService'
    import MemberChannelRateService from 'service/MemberChannelRateService'
    import MemberLevelRateService from 'service/MemberLevelRateService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "LevelList",
        props: {
            model: {
                type: Object,
                default: {}
            },
            show: {
                type: Boolean,
                default: false
            },
            levelNameList: {
                type: Array,
                default: () => []
            },
            needEdit: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                chnNameList: [],
                chnList: [],
                rateRule: {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请输入费率'))
                        } else if (value >= 2) {
                            callback(new Error('费率不能大于或等于2'))
                        } else {
                            const Index = rule.field.replace(/[^0-9]/ig,"");
                            this.checkOnly(value, Index, 'rate',res =>{
                                res.contents.checkFlag ? callback(new Error('会员费率不能小于机构费率')) : callback()
                            });
                        }
                    },
                },
                qpayRule: {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error('请输入代付费'))
                        } else {
                            const Index = rule.field.replace(/[^0-9]/ig,"");
                            this.checkOnly(value, Index, 'repay',res =>{
                                res.contents.checkFlag ? callback(new Error('会员代付费不能小于机构代付费')) : callback()
                            });
                        }
                    },
                },
                showList:false,
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {
                const params = {
                    qpayAmts:'',
                    qpayRates:'',
                };
                // if (this.model.id) {
                //     params.rateId = this.model.id;
                // }
                //
                // const checkParams = params;
                // checkParams.chnList = JSON.stringify(checkParams.chnList);

                return params;
            },

            ...mapGetters(['userId'])
        },
        mounted(){
            if (this.model.lineList != undefined && this.model.lineList.length) {
                this.showList = true;
                this.model.lineList.forEach(item => {
                    item.qpayAmt = item.qpayAmt * 100 / 10000;
                })
            }
        },
        watch:{
           'model.lineList' (val, oldVal){
               if (val != undefined && val.length) {
                   this.showList = true;
                   val.forEach(item => {
                       item.qpayAmt = item.qpayAmt * 100 / 10000;
                   })
               }
           }
        },
        methods: {
            checkOnly(rate,index, flag, onSuccess){

                const params = {
                    rate:rate,
                    flag:flag,
                    chnId:this.model.lineList[index].chnId,
                };
                this.doLoad(MemberLevelRateService.checkMemFee,params,res => {
                    this.doCheck(res,res =>{
                        onSuccess && onSuccess(res);
                    });
                },'信息获取失败')
            },
            submit(){
                this.$refs['model'].validate((valid) => {
                    if (valid) {
                        this.$emit('submit',true)
                    } else {
                        this.$emit('submit',false)
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            submitForm(formName) {
                this.chnList = [];
                for (let i = 0; i < this.model.chnList.length; i++) {
                    this.chnList.push({
                        qpayAmt: this.model.chnList[i].qpayAmt,
                        qpayRate: this.model.chnList[i].qpayRate,
                        chnId: this.model.chnList[i].chnId,
                    });
                    // id : this.model.chnList[i].id ? this.model.chnList[i].id : ''
                    if (this.model.chnList[i].id) {
                        this.chnList[i].id = this.model.chnList[i].id;
                    }
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.doLoad(MemberLevelService.updateMemRateLevelChnFee, this.submitData, res => {
                            this.doCheck(res, res => {
                                this.showSuccess(res.respMsg);
                                this.$emit('saveSuccess')
                            });
                        }, '信息获取失败')
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .level-name {
        margin-right: 20px;
    }

    .item-box {
        padding-left: 2em;
    }

    .levelBox {
        border: 1px solid #DDDDDD;
        padding: 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
    }

    .demo-dynamic p {
        /*width: 100px;*/
        width: 55px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 40px;
        margin-top: 0;
    }

    .demo-dynamic .lineName {
        width: 150px;
        /*width: 55px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 40px;
        margin-top: 0;
    }

    .item {
        margin-top: 20px;
    }

    .demo-dynamic .notice-text {
        margin: 30px auto 10px;
        color: #bfbfbf;
        width: auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/LevelList.vue